(function () {
  var observed = new WeakSet();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      initialize(entry.target);
    });
  }, { rootMargin: '350px' });

  function initialize(link) {
    var images;
    try { images = JSON.parse(link.dataset.cswSwipeImages); } catch (error) { return; }
    if (images.length < 2) return;
    var track = document.createElement('div');
    track.className = 'csw-card-track';
    var dots = document.createElement('div');
    dots.className = 'csw-card-dots';
    dots.setAttribute('aria-hidden', 'true');
    var width = Math.min(900, Math.ceil(link.getBoundingClientRect().width * Math.min(devicePixelRatio || 1, 2)));
    var primary = link.querySelector('.image__primary img');
    var slides = images.map(function (image, index) {
      var slide = document.createElement('div');
      slide.className = 'csw-card-slide';
      {
        var img = document.createElement('img');
        img.alt = image.alt || '';
        img.decoding = 'async';
        var url = new URL(image.src, location.href);
        url.searchParams.set('width', width);
        if (index === 0 && primary) {
          img.src = primary.currentSrc || primary.src || primary.dataset.src || url.href;
          if (!primary.currentSrc && primary.dataset.srcset) {
            img.srcset = primary.dataset.srcset;
            img.sizes = primary.sizes || '50vw';
          }
        } else {
          img.dataset.src = url.href;
        }
        slide.appendChild(img);
      }
      track.appendChild(slide);
      var dot = document.createElement('span');
      dot.className = index === 0 ? 'is-active' : '';
      dots.appendChild(dot);
      return slide;
    });
    function load(index) {
      var img = slides[index] && slides[index].querySelector('img[data-src]');
      if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
    }
    var active = 0;
    var suppressClick = false;
    var timer;
    var framePending = false;
    track.addEventListener('scroll', function () {
      suppressClick = true;
      clearTimeout(timer);
      timer = setTimeout(function () { suppressClick = false; }, 350);
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(function () {
        framePending = false;
        var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        if (index !== active) {
          dots.children[active].classList.remove('is-active');
          dots.children[index].classList.add('is-active');
          active = index;
          load(index);
          load(index + 1);
          load(index + 2);
          load(index - 1);
        }
      });
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); }
    });
    link.appendChild(track);
    link.parentNode.appendChild(dots);
    load(1);
    load(2);
  }
  function scan(root) {
    var links = root.querySelectorAll('[data-csw-swipe-images]');
    links.forEach(function (link) {
      if (observed.has(link)) return;
      observed.add(link);
      observer.observe(link);
    });
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.querySelector('[data-csw-swipe-images]')) scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
